export default "__VITE_ASSET__CYsDBPzl__"